import { useState } from 'react';
import { useGetAllDealerAgreementTypeQuery, useCreateDealerAgreementTypeMutation, useUpdateDealerAgreementTypeMutation, useDeleteDealerAgreementTypeMutation } from '../../../../../api/endpoints/dealerAgreementType';
import { useLanguage } from '../../../../../contexts/LanguageContext';
import { formatDateOnly } from '../../../../../utils/dateUtils';

export const useDealerAgreementTypeData = ({ dealerAddressBrandId, dealer, pageSize = 10, enabled = true }) => {
    const { th } = useLanguage();
    const [pageNumber, setPageNumber] = useState(1);

    const dealerId = dealer ? dealer.id : null;

    const { data = { items: [], count: 0 }, isLoading, isFetching, refetch } = useGetAllDealerAgreementTypeQuery({ dealerId, dealerAddressBrandId, pageNumber, pageSize }, { skip: !enabled });

    const [createAgreementType] = useCreateDealerAgreementTypeMutation();
    const [updateAgreementType] = useUpdateDealerAgreementTypeMutation();
    const [deleteAgreementType] = useDeleteDealerAgreementTypeMutation();

    const columns = [
        { field: 'type', header: th('customerAddressBrand.tabs.dealerAgreementType.columns.type'), body: (row) => getTypeLabel(row.type) },
        { field: 'agreementType', header: th('customerAddressBrand.tabs.dealerAgreementType.columns.agreementType'), body: (row) => getAgreementTypeLabel(row.agreementType) },
        { field: 'price', header: th('customerAddressBrand.tabs.dealerAgreementType.columns.price') },
        { field: 'curency', header: th('customerAddressBrand.tabs.dealerAgreementType.columns.currency') },
        {
            field: 'contractStartDate',
            header: th('customerAddressBrand.tabs.dealerAgreementType.columns.contractStartDate'),
            body: (row) => formatDateOnly(row.contractStartDate)
        },
        {
            field: 'contractEndDate',
            header: th('customerAddressBrand.tabs.dealerAgreementType.columns.contractEndDate'),
            body: (row) => formatDateOnly(row.contractEndDate)
        }
    ];

    const save = async (formData) => {
        try {
            const payload = {
                ...formData,
                dealerAddressBrandId,
                price: Number(formData.price),
                contractStartDate: formData.contractStartDate ? new Date(formData.contractStartDate).toISOString() : null,
                contractEndDate: formData.contractEndDate ? new Date(formData.contractEndDate).toISOString() : null
            };

            if (formData.id) {
                await updateAgreementType(payload).unwrap();
            } else {
                await createAgreementType(payload).unwrap();
            }
            refetch();
        } catch (error) {
            console.error('❌ Agreement type save error:', error);
        }
    };

    const remove = async (id) => {
        try {
            await deleteAgreementType({ id, dealerAddressBrandId }).unwrap();
            refetch();
        } catch (error) {
            console.error('❌ Agreement type delete error:', error);
        }
    };

    return {
        items: data.items,
        count: data.count,
        isLoading: isLoading || isFetching,
        pageNumber,
        setPageNumber,
        pageSize,
        save,
        remove,
        refetch,
        columns
    };
};

const getTypeLabel = (value) => {
    switch (value) {
        case 1:
            return 'Yol Yardımı';
        default:
            return '-';
    }
};

const getAgreementTypeLabel = (value) => {
    switch (value) {
        case 1:
            return 'KM';
        case 2:
            return 'Saat';
        default:
            return '-';
    }
};
